import { System, Entity, Velocity, InputManager, Keys } from '@badideagames/engine';
import { Flapper } from '../components/Flapper';

export class FlapSystem extends System {
  requiredComponents = [Velocity, Flapper];

  private input: InputManager;

  constructor(input: InputManager) {
    super();
    this.input = input;
  }

  update(entities: Entity[], _delta: number): void {
    const flap = this.input.isKeyPressed(Keys.Space) || this.input.isMousePressed(0);

    for (const entity of entities) {
      const flapper = entity.get(Flapper);
      if (!flapper.alive) continue;

      const velocity = entity.get(Velocity);

      if (flap) {
        velocity.vy = flapper.flapForce;
      }
    }
  }
}
